import React from "react";
const Confirmation = (props) => {
    const { msg, className = "" } = props;
    const { yesText, noText } = props;
    const { yesAction = () => { } } = props;
    const { noAction = () => { } } = props;
    return (
        <div className="alert" onClick={noAction}>
            <div
                className={`confirmation ${className}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    className="alert--content success"
                    style={{ width: "100%", padding: "30px 20px" }}
                >
                    {msg}
                </div>
                <div className="confirmation-bottom">
                    <button
                        id={`nobutton`}
                        style={{ display: "block" }}
                        className=""
                        onClick={() => noAction()}
                    >
                        {noText || "NO"}
                    </button>
                    <button
                        id={`yesbutton`}
                        style={{ display: "block" }}
                        className=""
                        onClick={() => yesAction()}
                    >
                        {yesText || "YES"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Confirmation;
